var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: [{ "hide-border": _vm.hideTabs }, "tabs-container"] },
    [
      _c(
        "v-tabs",
        {
          class: [{ "hide-tabs": _vm.hideTabs }, "tabs"],
          attrs: {
            "background-color": "transparent",
            "hide-slider": "",
            "show-arrows": "",
            "next-icon": _vm.icons.doubleArrowRight,
            "prev-icon": _vm.icons.doubleArrowLeft,
          },
          model: {
            value: _vm.selectedTabIndex,
            callback: function ($$v) {
              _vm.selectedTabIndex = $$v
            },
            expression: "selectedTabIndex",
          },
        },
        _vm._l(_vm.tabs, function (tab, tabIndex) {
          return _c(
            "v-tab",
            {
              key: `tab-${tabIndex}`,
              class: [
                {
                  "change-tab-styles": _vm.$vuetify.breakpoint.mdAndUp,
                  disabled: _vm.disabledTabs,
                  "hidden-tab": tab.hiddenTab,
                  "disabled-tab": tab.disabledTab,
                },
                "tab",
              ],
              attrs: {
                ripple: false,
                "active-class": "active",
                disabled: _vm.setDisabledTab(tabIndex),
              },
              on: {
                change: function ($event) {
                  return _vm.onTabChange(tabIndex, tab)
                },
              },
            },
            [
              _c("span", { staticClass: "tab-label" }, [
                _vm._v(_vm._s(tab.label)),
              ]),
              tab.total
                ? _c("span", { staticClass: "tab-total" }, [
                    _vm._v("(" + _vm._s(tab.total) + ")"),
                  ])
                : _vm._e(),
            ]
          )
        }),
        1
      ),
      _vm.renderTabSelectorComponent
        ? _c("TabSelectorComponent", {
            attrs: { idEntity: _vm.entity.type, disabled: _vm.disabledTabs },
            on: {
              beforeSave: _vm.onBeforeSaveTabsVisibility,
              afterSave: _vm.onAfterSaveTabsVisibility,
              onTabSelectorOpen: _vm.onBeforeOpenTabSelector,
            },
          })
        : _vm._e(),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.selectedCurrentTabIndex,
            callback: function ($$v) {
              _vm.selectedCurrentTabIndex = $$v
            },
            expression: "selectedCurrentTabIndex",
          },
        },
        _vm._l(_vm.tabs, function (tab, contentIndex) {
          return _c(
            "v-tab-item",
            {
              key: `tab-${contentIndex}`,
              staticClass: "tab-content",
              attrs: { transition: false, "reverse-transition": false },
            },
            [
              _vm.showTabSpinner
                ? _c("SpinnerLayerComponent", {
                    staticClass: "spinner-layer-container",
                  })
                : _vm._e(),
              _vm._l(tab.items, function (component, componentIndex) {
                return _c(
                  "div",
                  {
                    key: `component-${componentIndex}`,
                    staticClass: "dynamic-component-wrapper",
                  },
                  [
                    _vm.selectedCurrentTabIndex === contentIndex &&
                    _vm.everythingLoaded
                      ? _c(
                          _vm.renderTypeOfComponent(component.idSubTypeObject),
                          _vm._b(
                            {
                              key: _vm.componentKey,
                              ref: "currentRenderedComponent",
                              refInFor: true,
                              tag: "component",
                              on: {
                                saveFormData: _vm.onSaveFormData,
                                gridAction: _vm.onGridAction,
                                simpleGridActionNew: _vm.onSimpleGridActionNew,
                                simpleGridActionEdit:
                                  _vm.onSimpleGridActionEdit,
                                simpleGridActionRemove:
                                  _vm.onSimpleGridActionRemove,
                                openForm: _vm.onOpenForm,
                                closeForm: _vm.onCloseForm,
                                saveForm: _vm.onSaveForm,
                                isValidForm: _vm.onFormIsValid,
                                createdForm: _vm.onFormCreated,
                                mountedForm: _vm.onFormMounted,
                                disabledTabs: _vm.disabledTabsMethod,
                                enabledTabs: _vm.toggleStatusTabs,
                                setDisabledTabsMessage:
                                  _vm.setDisabledTabMessage,
                                removeItem: _vm.onTabHeaderRemoveItem,
                                "set-tandem-filter": _vm.setTandemFilter,
                                "change-breadcrumbs": _vm.changeBreadcrumbs,
                                expedientGlobalVisionComponentMounted:
                                  _vm.onExpedientGlobalVisionMounted,
                              },
                              model: {
                                value:
                                  component.idSubTypeObject ===
                                  _vm.componentType.form
                                    ? _vm.formData
                                    : false,
                                callback: function ($$v) {
                                  _vm.$set(
                                    component.idSubTypeObject ===
                                      _vm.componentType,
                                    "form ? formData : false",
                                    $$v
                                  )
                                },
                                expression:
                                  "component.idSubTypeObject === componentType.form ? formData : false",
                              },
                            },
                            "component",
                            _vm.setPropsDependingOnComponentType(
                              component,
                              tab,
                              _vm.selectedCurrentTabIndex
                            ),
                            false
                          )
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _vm.selectedCurrentTabIndex === contentIndex &&
              _vm.showRelatedForm(_vm.context)
                ? _c("RelatedForm", {
                    attrs: {
                      selectedRegisterId: _vm.currentId || "",
                      context: _vm.context,
                      endpoints: _vm.relatedEndpoints,
                      currentTabName: _vm.currentTabName,
                      editMode: _vm.editMode,
                      maintenanceType: _vm.currentComponent.maintenanceType,
                      permissionsEntityProp: _vm.permissionsEntityProp
                        ? _vm.permissionsEntityProp
                        : null,
                    },
                    on: {
                      "field-changed": _vm.onFieldChanged,
                      closeForm: _vm.onCloseForm,
                    },
                  })
                : _vm._e(),
            ],
            2
          )
        }),
        1
      ),
      _c("AlertComponent", {
        attrs: { whereIsRendered: _vm.componentWhereIsRendered },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }